// extracted by mini-css-extract-plugin
module.exports = {"navbar":"Navigation_navbar__21gIu","active":"Navigation_active__34I_c","logo":"Navigation_logo__19ZXk","logo-img":"Navigation_logo-img__10QIq"};